import User, { TUser } from "./user";
import {
  shortDateDisplay,
  shortDateTimeDisplay,
  parseDate,
} from "@atlas/tool/box/date/time-ts";
import type { TAttachment } from "@atlas/tool/box/file/types";
import Customer, { TCustomer } from "./customer";

export enum MessageSide {
  CUSTOMER = 1,
  AGENT = 2,
  BOT = 3,
}

export type TMessage = {
  id: string;
  text: string;
  sentAt: string;
  read: boolean;
  side: number;
  agent?: TUser;
  customerId?: string;
  customer?: TCustomer;
  attachments: TAttachment[];
};

class Message {
  public id: string;
  public text: string;
  public sentAt: string;
  public read: boolean;
  public side: MessageSide;
  public agent?: User;
  public customerId?: string;
  public customer?: Customer;
  public attachments: TAttachment[];

  constructor(data: TMessage) {
    this.id = data.id;
    this.text = data.text;
    this.sentAt = data.sentAt;
    this.read = data.read;
    this.side = data.side;
    this.attachments = data.attachments;
    this.customerId = data.customerId;

    if (data.agent) {
      this.agent = new User(data.agent);
    }
    if (data.customer) {
      this.customer = new Customer(data.customer);
    }
  }

  get sentAtDisplay() {
    return shortDateDisplay(parseDate(this.sentAt));
  }

  get sentAtLongDisplay() {
    return shortDateTimeDisplay(parseDate(this.sentAt));
  }

  get plainText() {
    return Object.assign(document.createElement("i"), {
      innerHTML: this.text.replace(/</g, " <"),
    }).innerText.trim();
  }
}

export default Message;
